"use client";

import { usePathname } from "next/navigation";
import AnalyticsTracker from "../analytics-tracker";
import ClientSiteHeader from "./ClientSiteHeader";
import SiteFooter from "./SiteFooter";

export default function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isAdminRoute = pathname?.startsWith('/admin') ?? false;

  return (
    <>
      {/* Skip to content link for accessibility - only show on non-admin routes */}
      {!isAdminRoute && (
        <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-gradient-to-r from-soft-gold to-gold-dark text-white px-6 py-3 rounded-2xl z-50 shadow-lg font-medium transition-all duration-300 hover:scale-105">
          Skip to main content
        </a>
      )}
      <AnalyticsTracker />
      {!isAdminRoute && <ClientSiteHeader />}

      <main id="main-content" className="relative">
        {children}
      </main>

      {!isAdminRoute && <SiteFooter />}
    </>
  );
}
